import { roleIsStaff } from "../../convex/model/access";
import type { Role } from "../../convex/model/enums";

export {
  roleCanManageClientUsers,
  roleCanWriteCompanyData,
  roleIsStaff,
  userCanManageClientUsers,
  userIsActive,
  userIsActiveClient,
  userIsClient,
} from "../../convex/model/access";

export const DEMO_STAFF_STORAGE_KEY = "lawstream.demoStaff" as const;
export const DEMO_STAFF_STORAGE_EVENT = "lawstream:demoStaff" as const;
export const DEMO_STAFF_STORAGE_VALUE = "true" as const;

export type AccessViewInput = {
  readonly clerkEnabled: boolean;
  readonly demoStaff: boolean;
  readonly role: Role | null | undefined;
};

export type AccessView = {
  readonly isDev: boolean;
  readonly isStaff: boolean;
};

export type DemoStaffStoredPreferenceInput = {
  readonly clerkEnabled: boolean;
  readonly storedValue: string | null;
};

export type DemoStaffStorageWrite =
  | { readonly kind: "noop" }
  | {
    readonly kind: "set";
    readonly key: typeof DEMO_STAFF_STORAGE_KEY;
    readonly eventName: typeof DEMO_STAFF_STORAGE_EVENT;
    readonly value: typeof DEMO_STAFF_STORAGE_VALUE;
  }
  | {
    readonly kind: "remove";
    readonly key: typeof DEMO_STAFF_STORAGE_KEY;
    readonly eventName: typeof DEMO_STAFF_STORAGE_EVENT;
  };

export const demoStaffPreferenceFromStoredValue = ({
  clerkEnabled,
  storedValue,
}: DemoStaffStoredPreferenceInput): boolean =>
  clerkEnabled && storedValue === DEMO_STAFF_STORAGE_VALUE;

export const demoStaffPreferenceWrite = ({
  clerkEnabled,
  enabled,
}: {
  readonly clerkEnabled: boolean;
  readonly enabled: boolean;
}): DemoStaffStorageWrite => {
  if (!clerkEnabled) return { kind: "noop" };
  return enabled
    ? {
      kind: "set",
      key: DEMO_STAFF_STORAGE_KEY,
      eventName: DEMO_STAFF_STORAGE_EVENT,
      value: DEMO_STAFF_STORAGE_VALUE,
    }
    : { kind: "remove", key: DEMO_STAFF_STORAGE_KEY, eventName: DEMO_STAFF_STORAGE_EVENT };
};

export const accessView = ({
  clerkEnabled,
  demoStaff,
  role,
}: AccessViewInput): AccessView => {
  const isDev = !clerkEnabled;
  return {
    isDev,
    isStaff: isDev || demoStaff || roleIsStaff(role),
  };
};
